import { memo } from 'react';

import classes from './links-block.module.scss';
import { LinksBlockProops } from './LinksBlock.type';

function LinksBlock({
  title,
  linksBlockItems,
  linksBlockShow = true,
}: LinksBlockProops) {
  return linksBlockShow && linksBlockItems.length > 0 ? (
    <div className={classes.container}>
      <p className={classes.heading}>{title}</p>
      <div className={classes.newsContainer}>
        {linksBlockItems.map((item) => (
          <a href={item.url} key={item.id} target="_blank" rel="noreferrer">
            <div className={classes.linkItem}>
              <img src={item.image} alt="" className={classes['linkItem-icon']} />
            </div>
          </a>
        ))}
      </div>
    </div>
  ) : null;
}

export default memo(LinksBlock);
